import { render } from "./AttachedEdit.vue?vue&type=template&id=2313cfe8"
import script from "./AttachedEdit.vue?vue&type=script&lang=js"
export * from "./AttachedEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__